import {ShapeFeaturePropsType} from "../components/geo-map/geo-map-elements/ShapeFeature";
import {
    extractScenesInformationFrom, getScenesInformationFrom,
} from "./cutSceneHelper";
import {
  isCutSceneAvailableByStacItem,
} from "./configurationHelper";
import {ShapeFeatureType, ShapeType} from "../types/shape";
import {getProductIdentifierFrom, isSameProductImageOf} from "./productHelper";
import {isProductImageQuicklookPreviewShownInMap} from "./quicklookPreviewHelper";
import {convertSelectedAreaInShapeFeature} from "./shapeHelper";
import {SELECT_SHAPE_COLOR} from "./geoMapHelper";
import {AdvancedSearchConfigurationsType, ConfigurationsType} from "../types/configurations";
import {
  AllInterferometricStacksType,
  InterferometricStackType,
  ProductImageStacType,
  SearchResultElementType,
  SearchResultsType
} from "../types/product";
import {QuicklookPreviewType} from "../types/geoMap";
import {
  isInterferometricStackSearchResultElement,
  isInterferometricStackSearchResults,
  isProductImageSearchResultElement,
  isSearchResultElementAvailable
} from "./searchResultsHelper";
import {
  doStackUpAllProductImagesBySameStrip,
  getAllInterferometricStacksSelected,
  getInterferometricStackIdentifierFrom,
  getProductImageFromInterferometricStack, stackUpAllProductImagesGroupedBySameStrip
} from "./interferometricStackHelper";
import {AppParametersType} from "../types/app";

const getSearchResultSelectedShapeFeatureProps = (defaultProps = {}, isInBackground = false) => ({
  ...defaultProps,
  color: "#e41b13",
  weight: isInBackground ? 1 : 3,
  opacity: isInBackground ? 0.5 : 1,
  fillOpacity: isInBackground ? 0.1 : 0.2,
  interactive: !!defaultProps['onClick'],
})

const getSearchResultDetailsShapeFeatureProps = (defaultProps = {}, isInBackground = false) => ({
  ...defaultProps,
  color: "#70AD47",
  weight: 3,
  opacity: 1,
  fillOpacity: 0.2,
  interactive: !!defaultProps['onClick'],
})

export const getSceneShapeFeatureProps = (defaultProps = {}, isInBackground = false) => ({
  ...defaultProps,
  color: "white",
  weight: 3,
  opacity: 1,
  fillOpacity: 0.2,
  interactive: !!defaultProps['onClick'],
    pane:'interferometric-stack-pane'
})

const getSelectedAreaShapeFeatureShapeProps = (defaultProps = {}, isInBackground = false, isKml = false) => ({
  ...defaultProps,
  key: "selected-area-shape",
  color: isKml ? '#ffbb00' : SELECT_SHAPE_COLOR,
  weight: 3,
  opacity: 0.5,
  fillOpacity: 0.2,
  interactive: !!defaultProps['onClick'],
})


export const getAllShapeFeaturesShownInMap = (
    configurations: ConfigurationsType,
    appParameters: AppParametersType,
    formValues: any,
    selectedProducts: ProductImageStacType[],
    searchResultDetails: SearchResultElementType,
    lastShape: ShapeType,
    quicklookPreviewsShownInMap: QuicklookPreviewType[],
    searchResults: SearchResultsType,
    allInterferometricStacks: AllInterferometricStacksType,
    onShapeClick: (element: SearchResultElementType) => {},
    isKml: boolean
): ShapeFeaturePropsType[] => {
  let shapesToRender: ShapeFeaturePropsType[] = isInterferometricStackSearchResults(searchResults)
      ? getInterferometricStackSearchResultsSelectedShapeFeatures(
          configurations as AdvancedSearchConfigurationsType,
          appParameters,
          formValues,
          selectedProducts,
          searchResultDetails,
          lastShape,
          allInterferometricStacks,
          onShapeClick
      )
      : getProductImageSearchResultsSelectedShapeFeatures(
          configurations,
          appParameters,
          formValues,
          selectedProducts,
          searchResultDetails,
          lastShape,
          quicklookPreviewsShownInMap,
          onShapeClick
      );

  if (isSearchResultElementAvailable(configurations, appParameters, searchResultDetails, selectedProducts, lastShape)) {
    shapesToRender = shapesToRender.concat(
        isInterferometricStackSearchResultElement(searchResultDetails)
            ? getInterferometricStackSearchResultDetailsShapeFeatures(
            configurations,
            appParameters,
            formValues,
            selectedProducts,
            searchResultDetails,
            lastShape,
            allInterferometricStacks,
            onShapeClick
            )
            : getProductImageSearchResultDetailsShapeFeatures(
            configurations,
            appParameters,
            formValues,
            selectedProducts,
            searchResultDetails,
            lastShape,
            quicklookPreviewsShownInMap,
            onShapeClick
            )
    )
  }

  if (!!lastShape) {
    shapesToRender = shapesToRender.concat([{
      shapeFeature: convertSelectedAreaInShapeFeature(lastShape),
      shapeFeatureProps: getSelectedAreaShapeFeatureShapeProps({}, false, isKml)
    }]);
  }

  return shapesToRender;
};







//////////////////////////////////////////////////////////////////////////
/////////////////// ProductImageShapeFeatures ////////////////////////////
//////////////////////////////////////////////////////////////////////////

const getProductImageShapeFeatures = (
  configurations: ConfigurationsType,
  formValues: any,
  lastShape: ShapeType,
  product: ProductImageStacType,
  productShapeProps: any
): ShapeFeaturePropsType[] => {
  let shapeFeatures: ShapeFeaturePropsType[] = [{
    shapeFeature: product as ShapeFeatureType,
    shapeFeatureProps: productShapeProps
  }];

  // @mapitaly - spostato fuori perchè async
  // if (isCutSceneAvailableByStacItem(configurations, formValues, lastShape, product)) {
  //   const {
  //     scenes
  //   } = extractScenesInformationFrom(lastShape, product);
  //
  //   shapeFeatures = shapeFeatures.concat(
  //     scenes.map((turfShape: ShapeFeatureType, index) => ({
  //       shapeFeature: turfShape,
  //       shapeFeatureProps: getSceneShapeFeatureProps({key: `${productShapeProps.key}-scene-${index}`})
  //     }))
  //   );
  // }

  return shapeFeatures;
};

const getProductImageSearchResultsSelectedShapeFeatures = (
  configurations: ConfigurationsType,
  appParameters: AppParametersType,
  formValues: any,
  selectedProducts: ProductImageStacType[] = [],
  searchResultDetails: SearchResultElementType,
  lastShape: ShapeType,
  quicklookPreviewsShownInMap: QuicklookPreviewType[],
  onShapeClick: (productImage: ProductImageStacType) => {}
): ShapeFeaturePropsType[] => {
  const isSearchResultDetailsAvailable = isSearchResultElementAvailable(configurations, appParameters, searchResultDetails, selectedProducts, lastShape);
  let visibleProductImages = selectedProducts.filter((product) => (
    !(
      isSearchResultDetailsAvailable &&
      isProductImageSearchResultElement(searchResultDetails) &&
      isSameProductImageOf(product)(searchResultDetails as ProductImageStacType)
    ) &&
    !isProductImageQuicklookPreviewShownInMap(quicklookPreviewsShownInMap, product)
  ));

  if (doStackUpAllProductImagesBySameStrip(configurations, appParameters, formValues, lastShape, false)) {
    visibleProductImages = stackUpAllProductImagesGroupedBySameStrip(visibleProductImages)
      .filter((p: ProductImageStacType | null) => !!p) as ProductImageStacType[] //removed null unions
  }

  return visibleProductImages
    .map((product) => getProductImageShapeFeatures(
      configurations,
      formValues,
      lastShape,
      product,
      getSearchResultSelectedShapeFeatureProps(
        {
          key: `selected-product-${getProductIdentifierFrom(product)}`,
          onClick: () => onShapeClick(product)
        },
        isSearchResultDetailsAvailable || isCutSceneAvailableByStacItem(configurations, formValues, lastShape, product)
      )
    ))
    .flat();
};

const getProductImageSearchResultDetailsShapeFeatures = (
  configurations: ConfigurationsType,
  appParameters: AppParametersType,
  formValues: any,
  selectedProducts: ProductImageStacType[],
  searchResultDetails: SearchResultElementType,
  lastShape: ShapeType,
  quicklookPreviews: QuicklookPreviewType[],
  onShapeClick: (productImage: ProductImageStacType) => {},
): ShapeFeaturePropsType[] => {
  return (
    isSearchResultElementAvailable(configurations,  appParameters, searchResultDetails, selectedProducts, lastShape) &&
    isProductImageSearchResultElement(searchResultDetails) &&
    !isProductImageQuicklookPreviewShownInMap(quicklookPreviews, searchResultDetails as ProductImageStacType)
  )
  ? getProductImageShapeFeatures(
      configurations,
      formValues,
      lastShape,
      searchResultDetails as ProductImageStacType,
      getSearchResultDetailsShapeFeatureProps(
        {
          key: `search-result-details-${getProductIdentifierFrom(searchResultDetails as ProductImageStacType)}`,
          onClick: () => onShapeClick(searchResultDetails as ProductImageStacType)
        },
          false
      )
    )
  : [];
};








//////////////////////////////////////////////////////////////////////////
/////////////////// InterferometricStackShapeFeatures ////////////////////
//////////////////////////////////////////////////////////////////////////
const getInterferometricStackShapeFeatures = (
  configurations: AdvancedSearchConfigurationsType,
  appParameters: AppParametersType,
  formValues: any,
  lastShape: ShapeType,
  selectedProducts: ProductImageStacType[],
  interferometricStack: InterferometricStackType,
  interferometricStackShapeProps: any
): ShapeFeaturePropsType[] => {
  let interferometricProductImage = getProductImageFromInterferometricStack(configurations, appParameters, interferometricStack, selectedProducts, lastShape);
  return !!interferometricProductImage
    ? getProductImageShapeFeatures(
      configurations,
      formValues,
      lastShape,
      interferometricProductImage,
      interferometricStackShapeProps
    )
    : []
};

const getInterferometricStackSearchResultsSelectedShapeFeatures = (
  configurations: AdvancedSearchConfigurationsType,
  appParameters: AppParametersType,
  formValues: any,
  selectedProducts: ProductImageStacType[],
  searchResultDetails: SearchResultElementType,
  lastShape: ShapeType,
  allInterferometricStacks: AllInterferometricStacksType,
  onShapeClick: (interferometricStack: InterferometricStackType) => {}
): ShapeFeaturePropsType[] => {
  return getAllInterferometricStacksSelected(allInterferometricStacks, selectedProducts)
    .map((interferometricStack) => getInterferometricStackShapeFeatures(
      configurations,
      appParameters,
      formValues,
      lastShape,
      selectedProducts,
      interferometricStack,
      getSearchResultSelectedShapeFeatureProps(
        {
          key: `selected-product-${getInterferometricStackIdentifierFrom(interferometricStack)}`,
          onClick: () => onShapeClick(interferometricStack)
        },
        isSearchResultElementAvailable(configurations,  appParameters, searchResultDetails, selectedProducts, lastShape)
      )
    ))
    .flat();
};

const getInterferometricStackSearchResultDetailsShapeFeatures = (
  configurations: ConfigurationsType,
  appParameters: AppParametersType,
  formValues: any,
  selectedProducts: ProductImageStacType[],
  searchResultDetails: SearchResultElementType,
  lastShape: ShapeType,
  allInterferometricStacks: AllInterferometricStacksType,
  onShapeClick: (interferometricStack: InterferometricStackType) => {}
): ShapeFeaturePropsType[] => {
  return (
    isSearchResultElementAvailable(configurations,  appParameters, searchResultDetails, selectedProducts, lastShape) &&
    isInterferometricStackSearchResultElement(searchResultDetails)
  )
  ? getInterferometricStackShapeFeatures(
      configurations as AdvancedSearchConfigurationsType,
      appParameters,
      formValues,
      lastShape,
      selectedProducts,
      searchResultDetails as InterferometricStackType,
      getSearchResultDetailsShapeFeatureProps(
        {
          key: `search-result-details-${getInterferometricStackIdentifierFrom(searchResultDetails as InterferometricStackType)}`,
          onClick: () => onShapeClick(searchResultDetails as InterferometricStackType)
        }
      )
    )
  : [];
};
